import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';

@Component({
  selector: 'app-consumption-line',
  templateUrl: './consumption-line.component.html',
  styleUrls: ['./consumption-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsumptionLineComponent implements OnInit {

  @Input() icon: string;
  @Input() name: string;
  @Input() subtext: string;
  @Input() value: string;
  @Input() color: string;
  @Input() colors: string[];
  @Input() ratio: number;
  @Input() ratios: number[];

  @Input() hasIcon = true;
  @Input() @HostBinding('class.is-cursor-pointer') hasArrow = false;
  @Input() @HostBinding('class.has-arrow-whitespace') hasArrowWhiteSpace = false;
  @Input() hasSubtext = false;

  @Input() measureType: EnumMeasureTypes;

  constructor() { }

  ngOnInit(): void {
  }

}
